// Aplica variables CSS de marca en el documento raíz.
// Contrato unificado con el portal: WebBrandConfig (GET /api/web-cms/brand).
// Solo escribe variables cuando el valor sea truthy, para no pisar defaults (_tokens.scss).
export const applyBrand = (brand) => {
  if (!brand || typeof document === 'undefined') {
    return;
  }
  const root = document.documentElement;

  if (brand.primaryColor) {
    root.style.setProperty('--primary-color', brand.primaryColor);
    // Hover de botones (brand.light): tono claro OPACO derivado de la marca.
    // No usar alfa (`${color}85`): vuelve el botón translúcido en hover (WEB_MLS-523).
    root.style.setProperty('--primary-color-light', `color-mix(in srgb, ${brand.primaryColor}, white 18%)`);
    root.style.setProperty('--color-primary', brand.primaryColor);
    root.style.setProperty('--color-primary-700', brand.primaryColor);
    // --color-primary-light se mantiene translúcido a propósito: es el focus-ring de inputs.
    root.style.setProperty('--color-primary-light', `${brand.primaryColor}85`);
  }
  if (brand.secondaryColor) {
    root.style.setProperty('--secondary-color', brand.secondaryColor);
    root.style.setProperty('--color-secondary', brand.secondaryColor);
  }
  if (brand.fontHeading) {
    root.style.setProperty('--font-heading', brand.fontHeading);
    root.style.setProperty('--font-display', brand.fontHeading);
  }
  if (brand.fontBody) {
    root.style.setProperty('--font-body', brand.fontBody);
    root.style.setProperty('--font-sans', brand.fontBody);
  }
  if (brand.logoUrl) {
    root.style.setProperty('--brand-logo-url', `url(${brand.logoUrl})`);
  }
};

export default applyBrand;
